if (!customElements.get("select-plan")) {
  class SelectPlan extends HTMLElement {
    constructor() {
      super();
      this.item = this.dataset.item;
      this.select = this.querySelector("select");
      this.selectedPlanId = this.dataset.selectedPlanId;
      this.selectedPlanName = this.dataset.selectedPlanName;
      this.planCheckbox = this.querySelector("[type=checkbox]");
      this.toggleText = this.querySelector(".toggle-text");
      this.getPlanValues();


      this.planCheckbox.addEventListener('change', ()=>{
        if(this.planCheckbox.checked){
          this.select.classList.remove('hide');
          this.toggleText.classList.add('hide');
          this.updateSelectIndex(1);
        } else {
          this.select.classList.add('hide');
          this.toggleText.classList.remove('hide');
          this.updateSelectIndex(0);
        }
      });
    }

    updateSelectIndex(value){
      this.select.selectedIndex = value;
      this.selectUpdate(value);
    } 

    selectUpdate(value) {
        var selectParent = this.select.closest("select-plan");
        var selectItem = selectParent.closest(".item");
    
        var selectCartItem = {
          id: `${selectParent.dataset.item}`,
          quantity: `${selectItem.querySelector(".quantity-input").value}`,
          selling_plan: `${
            this.select.options[value].value
          }`,
        };
        this.updatePlan(selectCartItem);
      }

     updatePlan(cartItem) {
      if (window.SideCart) {
        window.SideCart.postChange(cartItem);
      } else if (window.CartPage) {
        window.CartPage.postChange(cartItem);
      }
    }

    getCartPlans(selector) {
      var thisItem = selector.dataset.item;
      var thisSelect = selector.querySelector("select");
      $s.getJson({
        url: "/cart.json",
        success: (data) => {
          data.items.forEach((item) => {
            if (thisItem == item.key && item.selling_plan_allocation) {
              thisSelect.value = item.selling_plan_allocation.selling_plan.id;
            }
          });
        },
      });
    }



    getPlanValues() {
      this.getCartPlans(this);
    
      this.select.addEventListener("change", (e) => {
        this.selectUpdate(this.select.selectedIndex);
      });               

      
    }
  }
  customElements.define("select-plan", SelectPlan);
}
